import { InterestedPartner } from '../../../partnerSchool/interestedPartner';

export const InterestedPartners = () => {
  return <InterestedPartner />;
};
